import Vue from "vue";


export default function vailCode(rs, callback, errcallback) {
  if (rs.code == 0) {
    typeof callback == "function" && callback(rs);
  } else {
    Vue.toasted.error(rs.message);
    typeof errcallback == "function" && errcallback(rs);
    // Vue.prototype.$loading.hide();
  }
}
